import React, { useEffect } from 'react';
import { useStore } from '../../../../../stores/root';
import styles from './styles.module.scss';

// assets

// services

// props
import { IPaginationResourceShort } from '../../../../../props/general';

// components
import { ActionButton, CommandBar, IColumn, ICommandBarItemProps, IContextualMenuItem, PrimaryButton, SearchBox, SelectionMode, ShimmeredDetailsList, Stack } from '@fluentui/react';
import Text from '../../../../typography/text';
import OfficeForm from '../form';
import { IPublicOfficeResourceshort } from '../../../../../props/users/office';
import OfficeService from '../../../../../services/users/offices';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faXmark } from '@fortawesome/pro-light-svg-icons';
import OfficeTypes from '../../../../../manifests/PublicOfficeTypes';

interface IOfficesListProps {
}

const OfficesList: React.FC<IOfficesListProps> = (props: IOfficesListProps) => {
    const { banner } = useStore();
    const [loaded, setLoaded] = React.useState<boolean>(false);
    const [showingMore, setShowingMore] = React.useState<boolean>(false);
    const [offices, setOffices] = React.useState<IPublicOfficeResourceshort[]>([]);
    const [activeOffice, setActiveOffice] = React.useState<IPublicOfficeResourceshort | undefined>();
    const [pagination, setPagingation] = React.useState<IPaginationResourceShort | undefined>();
    const [keyword, setKeyword] = React.useState<string>("");
    const [activeSurface, setActiveSurface] = React.useState<string | undefined>();

    const columns: IColumn[] = [
        {
            key: 'name',
            name: 'Name',
            minWidth: 250,
            maxWidth: 250,
            onRender: (item: IPublicOfficeResourceshort) => {
                return <Stack>
                    <Text>{item.name}</Text>
                </Stack>;
            },
        },
        {
            key: "actions",
            name: "",
            minWidth: 50,
            maxWidth: 50,
            onRender: (item: IPublicOfficeResourceshort) => {
                let menuItems: IContextualMenuItem[] = [
                    {
                        key: "update", text: "Update details", iconProps: { iconName: "Edit" }, onClick: () => {
                            setActiveOffice(item);
                            setActiveSurface('update');
                        }
                    },
                    {
                        key: "delete",
                        text: "Delete",
                        iconProps: { iconName: "Delete" },
                        onClick: () => {
                            onDelete(item)
                        },
                    }
                ];

                return <Stack.Item styles={{ root: { padding: '2px 0px' } }}>
                    <Stack.Item className={"detailsListActionRow"}>
                        <ActionButton className={'detailsListActionButton'} menuProps={{
                            items: menuItems
                        }} />
                    </Stack.Item>
                </Stack.Item>;
            }
        },
        {
            key: 'address',
            name: 'Address',
            minWidth: 250,
            maxWidth: 250,
            onRender: (item: IPublicOfficeResourceshort) => {
                return <Stack>
                    <Text>{item.address}</Text>
                </Stack>;
            },
        },
        {
            key: 'longitude',
            name: 'Longitude',
            minWidth: 100,
            maxWidth: 100,
            onRender: (item: IPublicOfficeResourceshort) => {
                return <Stack>
                    <Text>{item.longitude}</Text>
                </Stack>;
            },
        },
        {
            key: 'latitude',
            name: 'Latitude',
            minWidth: 100,
            maxWidth: 100,
            onRender: (item: IPublicOfficeResourceshort) => {
                return <Stack>
                    <Text>{item.latitude}</Text>
                </Stack>;
            },
        },
        {
            key: 'type',
            name: 'Type',
            minWidth: 100,
            maxWidth: 100,
            onRender: (item: IPublicOfficeResourceshort) => {
                return (
                    <Stack>
                        <Text>{OfficeTypes.find(f => f.key === item.type) ? OfficeTypes.find(f => f.key === item.type)?.text : item.type}</Text>
                    </Stack>
                );
            },
        },
        {
            key: 'is_featured',
            name: 'Is Featured',
            minWidth: 50,
            maxWidth: 50,
            onRender: (item: IPublicOfficeResourceshort) => {
                return (
                    <Stack verticalAlign='center'>
                        <Stack horizontal>{item.is_featured ? <FontAwesomeIcon icon={faCheck} /> : <FontAwesomeIcon icon={faXmark} />}</Stack>
                    </Stack>
                );
            },
        },
    ];

    useEffect(() => {
        _onRetrieveOffices();
    }, []);

    useEffect(() => {
        _onRetrieveOffices();
    }, [keyword]);

    const _onRetrieveOffices = async (pageNumber?: number,) => {
        const qs: string[] = [];
        if (pageNumber) { qs.push(`page=${pageNumber}`); }
        if (keyword && keyword.trim() !== "") { qs.push(`search=${keyword}`) }
        try {
            const items = await OfficeService.retrieve(qs.join("&"))
            setOffices(items)

            setPagingation(undefined);
            setLoaded(true);
        } catch (error) {

        }
    }

    const _onKeywordChanged = (value?: string) => {
        setLoaded(true);
        setKeyword(value || "");
    }

    const getCommandBarItems = () => {
        let items: ICommandBarItemProps[] = [];
        let farItems: ICommandBarItemProps[] = [];

        items.push({
            key: "search",
            onRender: () => {
                return <SearchBox placeholder={"Search ..."} onSearch={_onKeywordChanged} />
            }
        });

        farItems.push({
            key: "register",
            text: "Create Office",
            iconProps: { iconName: "Add" },
            onRender: () => {
                return <PrimaryButton text={"Create Office"}
                    iconProps={{ iconName: "Add" }}
                    onClick={() => { setActiveSurface('create') }}
                    styles={{ root: { marginLeft: 10 } }} />;
            }
        });

        return { items, farItems };
    }

    const onDelete = async (item: IPublicOfficeResourceshort) => {
        if (window.confirm(`Hapus ${item.name}?`)) {
            setOffices([...offices.filter(f => f.id !== item.id)])
            try {
                await OfficeService.delete(item.id)
            } catch (error) {
            }
        }
    }

    const _onSurfaceDismissed = (refresh?: boolean) => {
        setActiveSurface(undefined);
        setActiveOffice(undefined);

        if (refresh) { _onRetrieveOffices() }
    }

    return <Stack className={styles.container} tokens={{ childrenGap: 20 }}>
        <CommandBar
            items={getCommandBarItems().items}
            farItems={getCommandBarItems().farItems}
            styles={{
                root: {
                    padding: 0,
                    height: 'unset',
                    backgroundColor: 'transparent'
                }
            }}
            ariaLabel="Use left and right arrow keys to navigate between commands" />
        <Stack className={styles.list}>
            {
                !loaded || (loaded && offices.length > 0) ? (
                    <>
                        <ShimmeredDetailsList
                            setKey="items"
                            items={offices}
                            columns={columns}
                            selectionMode={SelectionMode.none}
                            enableShimmer={!loaded}
                            onShouldVirtualize={() => false}
                            ariaLabelForShimmer="Content is being fetched"
                            ariaLabelForGrid="Item details" />
                    </>
                ) : null
            }
            {loaded && offices.length < 1 ? <Stack styles={{ root: { padding: 10 } }}>
                <Text>Office(s) not found</Text>
            </Stack> : null}
        </Stack>
        {activeSurface === 'create' ? <OfficeForm onDismissed={_onSurfaceDismissed} /> : null}
        {activeSurface === 'update' && activeOffice ? <OfficeForm officeId={activeOffice.id} onDismissed={_onSurfaceDismissed} /> : null}
    </Stack>;
};

export default OfficesList;
